import 'styles/embedHeaderFooter.scss';
import * as siteNavigation from 'scripts/components/siteNavigation.js';
import * as userGroupSelector from 'scripts/components/userGroupSelector.js';
import * as siteHeader from 'scripts/components/siteHeader.js';

const Embed = (function(window, document) {
  const config = {};

  const fn = {
    init: rootUrl => {
      config.rootUrl = rootUrl;
      config.$header = document.getElementById("embed-herkimer-header");
      config.$footer = document.getElementById("embed-herkimer-footer");
      config.endpoint = `${config.rootUrl}/header-footer-embed`;

      // Load Styles
      fetch(fn.getEndpointUrl("stylecss"))
        .then(response => response.text())
        .then(res => {
          const style = document.createElement("style");
          style.innerHTML = res;
          document.head.appendChild(style);
        });

      // Load Header
      fetch(fn.getEndpointUrl("header"))
        .then(response => response.text())
        .then(res => {
          config.$header.innerHTML = res;

          config.$header.style.position = "sticky";
          config.$header.style.top = "0";
          config.$header.style.zIndex = "1";

          let searchTrigger = document.querySelector('.site-search-trigger');
          let mobileSearchTrigger = document.querySelector('.js-site-search-trigger');
          let mobileNavSearch = document.querySelector('.site-nav__search')

          // Remove Search From Header
          searchTrigger.style.display = 'none';
          mobileSearchTrigger.style.display = 'none';
          mobileNavSearch.style.display = 'none';

          // Run Scripts After Header Is Loaded
          siteNavigation.default.run();
          siteHeader.default.run();
        });

      // Load Footer
      fetch(fn.getEndpointUrl("footer"))
        .then(response => response.text())
        .then(res => {
          config.$footer.innerHTML = res;

          // Remove Newsletter Signup From Footer
          let newsletterSignup = document.querySelector('.site-footer-subscribe-social .cell.xlarge-4');
          newsletterSignup.style.display = 'none';

          let termlyConsentManager = document.querySelector('.termly-display-preferences');
          termlyConsentManager.style.display = 'none';
        });
    },

    getEndpointUrl: path => {
      return `${config.endpoint}/${path}`;
    }
  };

  return {
    init: fn.init
  };
})(window, document);

if (document.getElementById("embed-herkimer-header") || document.getElementById("embed-herkimer-footer")) {
  Embed.init(window._embedRootUrl);

  userGroupSelector.default.run();
}
